import type { JsonValue, RecordDefinition, Transaction } from "@e308/core";
import { rejectIfEliminated } from "./command-guards.js";
import type { SeatModel } from "./content-types.js";
import type { Micro } from "./exact-numbers.js";
import { borderIsActive } from "./lifecycle-state.js";
import type { MatchLifecycleState } from "./lifecycle-types.js";

export function rejectUnlessActiveBorder(
  transaction: Transaction<Micro>,
  model: SeatModel,
  target: SeatModel,
  lifecycle: RecordDefinition<MatchLifecycleState & JsonValue>,
): void {
  if (
    !borderIsActive(transaction.getRecord(lifecycle), model.seat.id, target.seat.id) ||
    transaction.get(target.resources.headquarters) <= 0n
  )
    transaction.reject({ code: "invalid-target", id: target.seat.id });
}

export function activeBorderIds(
  transaction: Transaction<Micro>,
  model: SeatModel,
  lifecycle: RecordDefinition<MatchLifecycleState & JsonValue>,
): readonly string[] {
  const state = transaction.getRecord(lifecycle);
  return model.borderIds.filter((id) => borderIsActive(state, model.seat.id, id));
}

export function validateArmyDestinations(
  tx: Transaction<Micro>,
  model: SeatModel,
  ids: readonly string[],
  seats: ReadonlyMap<string, SeatModel>,
  lifecycle: RecordDefinition<MatchLifecycleState & JsonValue>,
): void {
  rejectIfEliminated(tx, model);
  for (const id of ids) {
    const target = seats.get(id);
    if (!target) throw new TypeError("Unknown border");
    rejectUnlessActiveBorder(tx, model, target, lifecycle);
  }
}
